module.exports = __webpack_public_path__ + "img/ic-email-square.b325e7ab.svg";